import { AuthEnums } from "@/enums/Enums";
import { useMeetActions } from "@/store/selectors/MeetSelectors";
import { useAuth } from "@nexus/shared-core";
import { Button, Col, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import logo from "../assets/images/logo.svg";

const { Title } = Typography;

const LoginMethodsForm = () => {
  const { setMeetDetail } = useMeetActions();

  const auth = useAuth();
  const { t } = useTranslation();

  const onLoginClicked = (mode: "login" | AuthEnums.EnterName) => {
    if (mode === "login") {
      auth?.signIn();
      return;
    }
    setMeetDetail({
      mode,
      token: null,
    });
  };

  return (
    <>
      <div className="form-wrapper">
        <div className="green-nexus-logo">
          <img src={logo} alt="" />
        </div>
        <Row justify={"start"} align={"middle"} gutter={[16, 16]}>
          <Col span={24}>
            <Title className="form-title" level={2}>
              {t("joinMeeting.joinMeeting")}
            </Title>
          </Col>
          <Col xl={12} lg={12} md={24} xs={24}>
            <Button
              type="primary"
              block
              onClick={() => onLoginClicked("login")}
            >
              {t("joinMeeting.login")}
            </Button>
          </Col>
          <Col xl={12} lg={12} md={24} xs={24}>
            <Button block onClick={() => onLoginClicked(AuthEnums.EnterName)}>
              {t("joinMeeting.joinAsGuest")}
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default LoginMethodsForm;
